<template>
  <div class="depository-table-wrapper">
    <el-row>
      <el-col :span="24">
          <el-table
              :data="this.getRenderItems"
              style="width: 100%">
            <el-table-column
                prop="name"
                label="Название">
            </el-table-column>
            <el-table-column
                label="Скачать"
                align="right">
              <template slot-scope="scope" v-if="getIsDownload">
                <el-button
                    size="mini"
                    @click="downloadFile(scope.$index, scope.row)">Скачать</el-button>
              </template>
            </el-table-column>
          </el-table>
      </el-col>
      <el-col :span="24">
        <el-pagination
            :hide-on-single-page="true"
            :page-size="this.getPaginationItemsInPage"
            :pager-count="7"
            layout="prev, pager, next"
            :total="this.getCountItems"
            @current-change="this.setPaginationPage">
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { mapGetters, mapMutations, mapActions } from 'vuex'
  export default {
    name: 'DepositoryList',
    computed: {
      ...mapGetters('depository', [
        'getCurrentSection',
        'getCurrentPaginationPage',
        'getPaginationItemsInPage',
        'getCountItems',
        'getRenderItems',
        'getIsDownload',
        'getCurrentCountDownload'
      ])
    },
    methods: {
      ...mapMutations('depository', [
        'setPaginationPage'
      ]),
      ...mapActions('depository', [
        'setCountDownload'
      ]),
      downloadFile: function (index, rows) {
        this.setCountDownload(this.getCurrentCountDownload + 1)
        let link = document.createElement('a')
        link.download = rows.name
        link.href = rows.path
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/DepositoryList.vue